import { render, staticRenderFns } from "./DataCorrectionFormFiles.vue?vue&type=template&id=4fefe3c2&scoped=true&"
import script from "./DataCorrectionFormFiles.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionFormFiles.vue?vue&type=style&index=0&id=4fefe3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefe3c2",
  null
  
)

export default component.exports